<sim-basic-material-dialog
	(closeClicked)="close()"
	[finished]="finished"
	[headerIcon]="{fontSet: 'fad', fontIcon: 'fa-trash'}"
	[headerText]="data.deleteTitle"
	[matDialogData]="data"
	[rect]="rect"
	[showActionDivider]="false"
	class="normalDuotoneHeaderIcon"
>
	<div dialogContent>
		<div class="bottom">
			<div class="text">
				<mat-icon class="waterSign"> warning </mat-icon>
				<div [innerHTML]="data.deleteText"></div>
			</div>
		</div>
	</div>

	<ng-container actions>
		<sim-button
			(onClick)="close({action: 'cancel'})"
			[color]="'accent'"
			[icon]="{fontSet: 'fad', fontIcon: 'fa-times'}"
			[label]="T.BUTTON_CANCEL"
		/>

		<sim-button
			(onClick)="close({action: 'ok'})"
			[color]="'warn'"
			[icon]="{fontSet: 'fad', fontIcon: 'fa-trash-alt'}"
			[label]="data.deleteButtonText ? data.deleteButtonText : (T.BUTTON_DELETE | translate)"
		/>
	</ng-container>
</sim-basic-material-dialog>
